import { useTranslator } from '@/hooks'
import { IconButton } from '@mui/material'
import { useState } from 'react'
import dayjs from 'dayjs'

interface AttendanceEmployeeInformationProps {
  dataEmployee: any
}

export const AttendanceEmployeeInformation = ({ dataEmployee }: AttendanceEmployeeInformationProps) => {
  const { __ } = useTranslator()
  const [showMore, setShowMore] = useState(false)

  return (
    <div className='p-5'>
      <div className='flex items-center gap-2 justify-between border-b border-[#2f2b3d1f] pb-1'>
        <div className='text-[18px] font-medium text-[#2f2b3d]'>{__('Employee Information')}</div>
        <IconButton
          className='rounded-[10px]'
          onClick={() => {
            setShowMore(!showMore)
          }}
        >
          <div className='flex items-center gap-2'>
            <span className='text-[13px] font-medium text-[#2f2b3db3]'>
              {showMore ? __('View Less') : __('View More')}
            </span>
            {showMore ? (
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle
                  cx='12'
                  cy='12'
                  r='9'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M12 8L8 12'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M12 8V16'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M16 12L12 8'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : (
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle
                  cx='12'
                  cy='12'
                  r='9'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M8 12L12 16'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M12 8V16'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M16 12L12 16'
                  stroke='#2F2B3D'
                  strokeOpacity='0.7'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}
          </div>
        </IconButton>
      </div>
      <div className='grid grid-cols-4 gap-x-3 gap-y-5 mt-3'>
        <div>
          <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Employee Name')}</div>
          <div className='text-[15px] font-medium text-[#2f2b3de6]'>
            {dataEmployee?.data?.data?.user?.first_name || '-'}
          </div>
        </div>
        <div>
          <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Company Name')}</div>
          <div className='text-[15px] font-medium text-[#2f2b3de6]'>
            {dataEmployee?.data?.data?.user?.company?.name || '-'}
          </div>
        </div>
        <div>
          <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Employee Code')}</div>
          <div className='text-[15px] font-medium text-[#2f2b3de6]'>
            {dataEmployee?.data?.data?.user?.employee_id || '-'}
          </div>
        </div>
        <div>
          <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Joined Date')}</div>
          <div className='text-[15px] font-medium text-[#2f2b3de6]'>
          {dataEmployee?.data?.data?.user?.joined_date ? dayjs(dataEmployee?.data?.data?.user?.joined_date).format('DD/MM/YYYY') : '-'}
          </div>
        </div>
        {/* check show view more */}
        {showMore && (
          <>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Contract Type')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.contract_type || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Phone')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.phone_code && `(${dataEmployee.data.data.user.phone_code}) `}
                {dataEmployee?.data?.data?.user?.phone || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Bank Name')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.bank?.shortName || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Bank Account')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.bank_account_number || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Identity Card')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.identity_card || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Identity Card Issue Date')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.identity_card_issue_date === null
                  ? '-'
                  : dayjs(dataEmployee?.data?.data?.user?.identity_card_issue_date).format('DD/MM/YYYY')}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Identity Card Issue Place')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.identity_card_issue_place || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Gender')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.gender || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Address')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.address || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('D.O.B')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.birth_date === null
                  ? '-'
                  : dayjs(dataEmployee?.data?.data?.user?.birth_date).format('DD/MM/YYYY')}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Dependent')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.dependent || '-'}
              </div>
            </div>
            <div>
              <div className='text-[15px] font-normal text-[#2f2b3d66] mb-1'>{__('Tenure')}</div>
              <div className='text-[15px] font-medium text-[#2f2b3de6]'>
                {dataEmployee?.data?.data?.user?.tenure || '-'}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
